// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Creates a grid of uniformly-wide tiles
 *
 * IE 11 doesn't support key grid features like auto-placement,
 * so we have to make do with flexbox.
 *
 * Using this requires you to create N empty <divs> inside your container,
 * where N is the maximum number of tiles you expect to see in a given row.
 * These extra divs will prevent the last row of *real* tiles from growing
 * to fill the entire width (which breaks the vertical alignment of the tile
 * edges) by horizontally growing at the same rate as the real tiles. Any
 * excess tiles wrap to the next line, but because they have zero height they
 * won't take up any space.
 *
 * @param \$minTileWidth - Minimum tile size before they wrap
 * @param \$tileSpacing - Spacing between the tiles
 * @param \$spacerClassName - Class name of the spacer tile
 */
.room-content .room-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 32px;
  gap: 14px;
}
.room-content .room-header .room-divider {
  display: flex;
  padding: 16px 0;
  align-items: center;
  align-self: stretch;
}
.room-content .room-header .room-header-text {
  display: flex;
  align-items: start;
  width: 100%;
  font-size: 28px;
  gap: 24px;
}
.room-content .room-header .room-header-text .nkl-typography {
  flex: 1 1 auto;
  min-width: 0;
}
.room-content .room-header .room-header-text .room-tag {
  margin-left: auto;
  flex: 0 0 auto;
  white-space: nowrap;
}
.room-content .room-header .room-header-text .room-tag .nkl-tag,
.room-content .room-header .room-header-text .room-tag .nkl-tag-color {
  white-space: nowrap;
}
.room-content .room-header .room-header-text .room-tag .empty-room-tag.ant-tag {
  background-color: #f5f5f5;
  color: #262626;
  border: 1px solid #d9d9d9;
}
.room-content .room-cabinet-list {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
}
.room-content .room-cabinet-list > * {
  margin-left: 10px;
  margin-right: 10px;
  min-width: 160px;
}
@media (min-width: 1088px) {
  .room-content .room-cabinet-list > * {
    margin-left: 12px;
    margin-right: 12px;
    min-width: 160px;
  }
}
@media (min-width: 768px) and (max-width: 1087px) {
  .room-content .room-cabinet-list > * {
    margin-left: 11px;
    margin-right: 11px;
    min-width: 160px;
  }
}
@media (min-width: 736px) and (max-width: 767px) {
  .room-content .room-cabinet-list > * {
    margin-left: 12px;
    margin-right: 13px;
    min-width: 160px;
  }
}
.room-content .room-cabinet-list > *:not(.room-cabinet-list-spacer) {
  margin-top: 10px;
  margin-bottom: 10px;
}
/*  MOBILE ONLY */
@media (max-width: 768px) {
  .room-content .room-header .room-header-text {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .room-content .room-header .room-header-text .room-tag {
    margin-left: 0;
    padding-top: 4px;
  }
}
@media (min-width: 1088px) {
  .room-container-grid {
    width: 1175px;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
